<template>
    <v-row dense class="mb-4">
        <v-col v-for="stat in stats" :key="stat.label" cols="6" md="4">
            <v-card flat :color="stat.color + ' lighten-5'" class="pa-3 text-center stat-card" height="80">
                <div class="text-caption text-truncate">{{ stat.label }}</div>
                <div :class="stat.color + '--text'" class="text-h6 font-weight-bold text-truncate">
                    {{ stat.value }}
                </div>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'CalculatorStats',
    props: {
        stats: { type: Array, required: true }
    }
}
</script>

<style scoped>
.stat-card {
    transition: all 0.2s ease;
    cursor: default;
}

.stat-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

@media (max-width: 600px) {
    .stat-card {
        height: 70px !important;
    }

    .text-h6 {
        font-size: 1rem !important;
    }
}
</style>
